<template>
  <div class="feedback_box" v-loading.fullscreen.lock="showLoading">
    <!-- Search Header -->
    <div class="search-header">
      <div class="search-controls">
        <el-input
          v-model="searchKeyword"
          placeholder="请输入关键词"
          class="input_box"
          clearable
          @input="debouncedSearch"
          @keyup.enter.native="handleSearch"
          aria-label="搜索框"
        ></el-input>
        
        <el-date-picker
          v-model="searchDateRange"
          type="daterange"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :picker-options="dateRangePickerOptions"
          class="input_box input_date"
          @change="handleSearch"
        ></el-date-picker>

        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="warning" @click="fillVip">VIP处理</el-button>
        <el-button type="success" @click="fillWheel">转盘</el-button>
      </div>
    </div>

    <div class="data_box">
      <!-- Table View (Desktop) -->
      <template v-if="isTable">
        <el-table
            class="table"
            @sort-change="sortChange"
            border
            :data="feedbacks"
            style="width: 100%"
            @selection-change="feedbackChange">
          <el-table-column
              type="selection"
              width="55">
          </el-table-column>
          <el-table-column
              align="center"
              prop="id"
              label="id"
              width="80">
          </el-table-column>
          <el-table-column
              prop="userIdentify"
              align="center"
              label="用户标识"
              width="180">
          </el-table-column>
          <el-table-column
              align="center"
              prop="contact"
              label="联系方式"
              width="200">
          </el-table-column>
          <el-table-column
              prop="comment"
              align="center"
              label="反馈内容"
              width="400">
            <template slot-scope="scope">
              <span v-html="highlight(scope.row.comment)"></span>
            </template>
          </el-table-column>

          <el-table-column
              align="center"
              label="反馈截图"
              width="180">
            <template slot-scope="scope">
              <div v-for="item in parseResList(scope.row.resList)" :key="item"
                   style="display: inline-block; margin: 5px;">
                <a :href="item.indexOf('http') === 0 ? item : imageBaseUrl + item" target="_blank">
                  <el-image
                      style="width: 100px; height: 100px"
                      :src="item.indexOf('http') === 0 ? item : imageBaseUrl + item"
                      fit="cover"></el-image>
                </a>
              </div>
            </template>
          </el-table-column>

          <el-table-column
              align="center"
              sortable="custom"
              prop="time"
              label="反馈时间"
              width="180">
          </el-table-column>

          <el-table-column
              align="center"
              sortable="custom"
              prop="version"
              label="版本"
              width="100">
          </el-table-column>

          <el-table-column
              align="center"
              sortable="custom"
              prop="channel"
              label="渠道"
              width="100">
          </el-table-column>
          <el-table-column
              align="center"
              prop="deal"
              label="处理是否"
              width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.deal == 1 ? 'success' : 'danger'">
                {{ (scope.row.deal == 1 ? "是" : "否") }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              min-width="240">
            <template slot="header" slot-scope="scope">
              <span>操作</span>
              <a href="javascript:;" @click="getFeedbackList" class="a_class">刷新</a>
              <a href="javascript:;" @click="delfeedbacks" class="a_class">删除</a>
            </template>
            <template slot-scope="scope">
              <el-button type="primary" size="medium" @click="onDeal(scope.row.id)">处理完成</el-button>
              <el-button type="primary" size="medium" @click="showDetails(scope.row)">去处理</el-button>
              <el-button type="danger" size="medium" icon="el-icon-delete" @click="delFeedback(scope.row.id)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <!-- Card View (Mobile) -->
      <template v-else>
        <div class="card-list">
          <div v-if="feedbacks.length === 0" class="empty-state">
            暂无数据
          </div>
          <el-card v-for="item in feedbacks" :key="item.id" class="feedback-card" shadow="hover">
            <div slot="header" class="card-header">
              <span class="card-title">#{{ item.id }}</span>
              <el-tag size="small" type="info">{{ item.channel || '未知渠道' }}</el-tag>
            </div>
            <div class="card-body">
              <div class="card-row">
                <label>用户标识：</label>
                <span>{{ item.userIdentify }}</span>
              </div>
              <div class="card-row">
                <label>反馈内容：</label>
                <div class="content-highlight" v-html="highlight(item.comment)"></div>
              </div>
              <div class="card-row">
                <label>时间：</label>
                <span>{{ item.time }}</span>
              </div>
              <div class="card-row">
                <label>状态：</label>
                <el-tag :type="item.deal == 1 ? 'success' : 'danger'" size="mini">
                  {{ item.deal == 1 ? "已处理" : "未处理" }}
                </el-tag>
              </div>
            </div>
            <div class="card-actions">
               <el-button type="primary" size="small" @click="onDeal(item.id)">处理完成</el-button>
               <el-button type="primary" size="small" @click="showDetails(item)">去处理</el-button>
            </div>
          </el-card>
        </div>
      </template>

      <div class="page">
        <el-pagination
            background
            :page-size="pageCount"
            :current-page="pageNo"
            :layout="isTable ? 'prev, pager, next' : 'prev, next'"
            :page-count="pageSum"
            @current-change="changePage">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="dialogTitle"
               top="5vh"
               :visible.sync="showDialog"
               :close-on-click-modal="false"
               width="800px"
               :destroy-on-close="true"
               :fullscreen="false">
      <ShowFeedback :feedback="selectFeedback"/>
    </el-dialog>
  </div>
</template>

<script>
import ShowFeedback from "./ShowFeedback";
import router from '@/router';
import {dateRangePickerOptions} from '@/base_js/dateRangePickerOptions';

const baseUrl = process.env.VUE_APP_IMAGE_HOST;
export default {
  name: "Feedback",
  components: {
    ShowFeedback
  },
  data: function () {
    return {
      dialogTitle: "反馈详情",
      showDialog: false,
      showLoading: false,
      feedbacks: [],
      pageNo: 1,
      pageCount: 20,
      orderType: 2,
      pageSum: 1,
      selectFeedback: {},
      delFeedbackIds: [],
      imageBaseUrl: baseUrl + 'postImageUrl/',//预览图片地址
      
      // Search related
      searchKeyword: '',
      searchDateRange: [],
      dateRangePickerOptions,
      debouncedSearch: null,
      isTable: true,
    }
  },
  created() {
    this.debouncedSearch = this.debounce(this.handleSearch, 300);
  },
  mounted() {
    this.$bus.$emit("setMenuActiveIndex", "2-1-1");
    this.getFeedbackList();
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    // 防抖函数
    debounce(func, wait) {
      let timeout;
      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(context, args);
        }, wait);
      };
    },
    
    // 检查屏幕尺寸
    checkScreenSize() {
      this.isTable = window.innerWidth >= 1024;
    },

    // 搜索处理
    handleSearch() {
      // 确保日期选择器清空时 searchDateRange 不为 null
      if (!this.searchDateRange) {
        this.searchDateRange = [];
      }
      this.pageNo = 1;
      this.getFeedbackList();
    },

    // 填充VIP
    fillVip() {
      this.searchKeyword = 'VIP vip 退款 会员 开通 充值 同步 钱 付款 支付 解锁';
      this.searchDateRange = []; // 清空时间筛选，避免干扰
      this.handleSearch();
    },

    // 填充转盘
    fillWheel() {
      this.searchKeyword = '转盘';
      this.searchDateRange = []; // 清空时间筛选，避免干扰
      this.handleSearch();
    },

    // 高亮匹配
    highlight(text) {
      if (!text) return '';
      if (!this.searchKeyword) return text;
      // 支持多个关键词高亮
      const keywords = this.searchKeyword.split(/[\s,]+/).filter(k => k);
      if (keywords.length === 0) return text;

      let result = text;
      keywords.forEach(key => {
        // 转义正则特殊字符
        const keyword = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(${keyword})`, 'gi');
        result = result.replace(regex, '<mark>$1</mark>');
      });
      return result;
    },

    parseResList(resList) {
      // console.log("parseResList", resList)
      try {
        if (resList == null) return []
        // 去掉首尾的方括号，然后按逗号分隔，并去除每个项目的空格
        return resList.slice(1, -1).split(',').map(item => item.trim());
      } catch (e) {
        console.error('Error parsing resList:', e);
        return [];
      }
    },
    onDeal: function (id) {
      this.showLoading = true;
      const that = this;
      const params = new URLSearchParams()
      params.append("ids", id)
      this.$request.post("/feedback/dealFeedback", params)
          .then(function (data) {
            that.showLoading = false;
            if (data.status === 200) {
              that.$message.success("处理成功");
              that.getFeedbackList();
            } else {
              that.showError(data.data)
            }
          }).catch(function (err) {
        that.showLoading = false;
        that.showMsg("网络错误")
      })
    },
    getFeedbackList: function () {
      this.showLoading = true;
      const that = this;
      
      const isSearch = !!this.searchKeyword || (this.searchDateRange && this.searchDateRange.length > 0);
      
      // Since backend search API is missing (404), we implement frontend search as a fallback
      if (isSearch) {
        // Fetch a large number of records to perform client-side filtering
        // Ideally, backend should support search. This is a temporary workaround.
        const params = new URLSearchParams();
        params.append("pageNo", 1);
        params.append("pageCount", 1000); // Fetch up to 1000 records
        params.append("orderType", this.orderType);
        params.append("isPage", 1);

        this.$request.post("/feedback/getFeedbackList", params)
          .then(function (data) {
            if (data.status === 200) {
              let allRecords = data.data.records;
              
              // Filter by keyword
              if (that.searchKeyword) {
                const keywords = that.searchKeyword.toLowerCase().split(/[\s,]+/).filter(k => k);
                allRecords = allRecords.filter(item => {
                  if (keywords.length === 0) return true;
                  return keywords.some(keyword => {
                    return (item.comment && item.comment.toLowerCase().includes(keyword)) ||
                           (item.userIdentify && item.userIdentify.toLowerCase().includes(keyword)) ||
                           (item.contact && item.contact.toLowerCase().includes(keyword));
                  });
                });
              }
              
              // Filter by date range
              if (that.searchDateRange && that.searchDateRange.length === 2) {
                const startTime = new Date(that.searchDateRange[0]).getTime();
                const endTime = new Date(that.searchDateRange[1]).getTime() + 86400000; // Include end date
                allRecords = allRecords.filter(item => {
                  const itemTime = new Date(item.time).getTime();
                  return itemTime >= startTime && itemTime < endTime;
                });
              }
              
              // Manual pagination
              that.pageSum = Math.ceil(allRecords.length / that.pageCount);
              const start = (that.pageNo - 1) * that.pageCount;
              const end = start + that.pageCount;
              that.feedbacks = allRecords.slice(start, end);
              
              that.showLoading = false;
            } else {
              that.showMsg(data.data);
              that.showLoading = false;
            }
          }).catch(function (err) {
            that.showLoading = false;
            that.showMsg("网络错误");
          });
          return;
      }

      // Normal list fetching (no search)
      const params = new URLSearchParams()
      params.append("pageNo", this.pageNo)
      params.append("pageCount", this.pageCount)
      params.append("orderType", this.orderType)
      params.append("isPage", 1)

      this.$request.post("/feedback/getFeedbackList", params)
          .then(function (data) {
            if (data.status === 200) {
              that.feedbacks = data.data.records
              that.pageSum = data.data.pages
              that.showLoading = false
            } else {
              that.showMsg(data.data)
              that.showLoading = false
            }
          }).catch(function (err) {
        that.showLoading = false
        that.showMsg("网络错误")
      })
    },

    //删除多个反馈
    delfeedbacks: function () {
      this.$confirm('此操作将永久删除选中的文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        cancelButtonClass: "messagebox-off-button-color",
        confirmButtonClass: "messagebox-ok-button-color"
      }).then(() => {
        this.delAll()
      }).catch(() => {
      });
    },
    /**
     * 删除选中的数据
     */
    delAll: function () {
      if (this.delFeedbackIds === undefined || this.delFeedbackIds.length === 0) {
        return
      }
      this.showLoading = true;
      const that = this;
      const params = new URLSearchParams()
      this.delFeedbackIds.forEach((item) => {
        params.append("ids", item)
      })
      this.$request.post("/feedback/delFeedback", params)
          .then(function (data) {
            that.showLoading = false;
            if (data.status === 200) {
              that.$confirm("删除成功", "提示", {
                confirmButtonText: '确定',
                showClose: false,
                showCancelButton: false,
                center: true,
                type: 'success'
              }).then(function () {
                that.getFeedbackList()
              })
            } else {
              that.showError(data.data)
            }
          }).catch(function (err) {
        that.showLoading = false;
        that.hideLoading()
        that.showError("网络错误")
      })
    },
    /**
     * 显示错误消息
     * @param title
     */
    showMsg: function (title) {
      this.$confirm(title, "提示", {
        confirmButtonText: '确定',
        showClose: false,
        showCancelButton: false,
        center: true,
        type: 'error'
      })
    },
    changePage: function (pageNo) {
      this.pageNo = pageNo;
      this.getFeedbackList()
    },
    sortChange: function ({column, prop, order}) {
      switch (order) {
        case "ascending":
          //升序
          this.orderType = 1;
          break;
        case "descending":
          //升序
          this.orderType = 2;
          break;
        case null:
          //升序
          this.orderType = 0;
          break;
      }
      this.pageNo = 1;//重置页码
      this.getFeedbackList()
    },
    delFeedback: function (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        cancelButtonClass: "messagebox-off-button-color",
        confirmButtonClass: "messagebox-ok-button-color"
      }).then(() => {
        this.del(id)
      }).catch(() => {
      });
    },
    del: function (id) {
      this.showLoading = true;
      const that = this;
      const params = new URLSearchParams()
      params.append("id", id)
      this.$request.post("/feedback/delFeedback", params)
          .then(function (data) {
            that.showLoading = false;
            if (data.status === 200) {
              that.$confirm("删除成功", "提示", {
                confirmButtonText: '确定',
                showClose: false,
                showCancelButton: false,
                center: true,
                type: 'success'
              }).then(function () {
                that.getFeedbackList()
              })
            } else {
              that.showMsg(data.data)
            }
          }).catch(function (err) {
        that.showLoading = false;
        that.showMsg("网络错误")
      })
    },
    showDetails: function (feedback) {
      // 在新浏览器标签页中打开会员问题处理页面，并传递用户标识
      const basePath = process.env.VUE_APP_PATH ? '/' + process.env.VUE_APP_PATH : '';
      const url = `${basePath}/#/index/vipProblemManager?userId=${feedback.userIdentify}`;
      window.open(url, '_blank');
    },
    feedbackChange: function (data) {
      //清空数组
      this.delFeedbackIds = new Array();
      //遍历选中的重新赋值
      data.forEach((item) => {
        this.delFeedbackIds.push(item.id)
      })
    },
  }
}
</script>

<style scoped>
.feedback_box {
  width: 100%;
  min-height: 100%;
  background: white;
  border-radius: 5px;
  padding: 10px 20px;
}

.search-header {
  padding: 10px 0;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.search-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.input_box {
  width: 200px;
}
.input_date {
    width: 350px;
}

.box_operation {
  width: 100%;
  padding: 20px 0;
}

.data_box {
  width: 100%;
}

.page {
  width: 100%;
  margin: 20px 0;
  text-align: center;
}

.a_class {
  color: #409EFF;
  font-size: 14px;
  font-weight: 600;
  margin-left: 30px;
}

.table {
  /*position: fixed;*/
  height: 100%;
}

/* Card List Styles */
.card-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.feedback-card {
  margin-bottom: 10px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-weight: bold;
}

.card-body {
  padding: 10px 0;
}

.card-row {
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
}

.card-row label {
  color: #909399;
  font-size: 12px;
  margin-bottom: 4px;
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
  border-top: 1px solid #f0f0f0;
  padding-top: 10px;
}

.empty-state {
  text-align: center;
  color: #909399;
  padding: 40px;
}

/* Highlight style */
/deep/ mark {
  background-color: yellow;
  color: black;
  padding: 0 2px;
  border-radius: 2px;
}
</style>